import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import { Namespace } from '../../enum';
import {
    State,
    mapStateToProps,
} from './selector';
import reducer from './reducer';
import * as avcActions from './action';
import saga from './saga';
import { Inputs } from './enum';
import {
    AvcFormId,
    AvcResultId,
    CheckedAddressId,
} from '../../enums/elementId';
import { mountFormElement } from '../../components/formElement';
import { formValidation } from '@vfde-brix/ws10/validation';
import { formValidationHandleBtnDisable } from '@vfde-brix/ws10/validation/base/submitButtonHandler';
import { mountButton } from '../../components/button';
import { getUpdateFlags } from './update';
import { setElementVisibility } from '../../util/visibility';
import { ErrorType } from '../App/enum';
import { getMultipleAddressSelectProps } from '../../util/components/formElement.util';
import {
    cityValidations,
    houseNumberValidations,
    streetValidations,
} from '../../util/validator';
import { setOverlayVisibility } from '../Overlay/action';
import { deleteAddress } from '../App/action';
import { mountButtonLink } from '../../components/buttonLink';
import { OverlayContent } from '../Overlay/enum';
import { mountTooltip } from '../../components/tooltip';
import { mountCaptcha } from '../../components/mtCaptcha';
import { getAvcResultNotificationProps } from '../../util/components/notification.util';
import { getAvcJustTextProps } from '../../util/components/justText.util';
import { getAvcResultButtonProps } from '../../util/components/button.util';
import { mountNotification } from '../../components/notification';
import { mountJustText } from '../../components/justText';
import { toAddressString } from '@vfde-sails/avc-core';

const mapDispatch = {
    ...avcActions,
    setOverlayVisibility,
    deleteAddress,
};

function container (state: State, actions: typeof mapDispatch) {
    injectReducer(Namespace.AVC, reducer);
    injectSaga(Namespace.AVC, saga);

    const cityOnChange = (value: string) => actions.setInput(Inputs.CITY, value);
    const streetOnChange = (value: string) => actions.setInput(Inputs.STREET, value);
    const numberOnChange = (value: string) => actions.setInput(Inputs.NUMBER, value);

    const cityInput = mountFormElement(AvcFormId.CITY_INPUT, cityOnChange, cityValidations);
    const streetInput = mountFormElement(AvcFormId.STREET_INPUT, streetOnChange, streetValidations);
    const houseNumberInput = mountFormElement(AvcFormId.HOUSE_INPUT, numberOnChange, houseNumberValidations);
    const select = mountFormElement(AvcFormId.MULTIPLE_ADDRESS_SELECT, actions.setSelectedAddress);
    const submitButton = mountButton(AvcFormId.BUTTON, actions.checkAddress);

    mountTooltip(AvcFormId.SUBLINE_TOOLTIP);
    mountTooltip(AvcFormId.MOVE_CASE_TOOLTIP);
    mountCaptcha();

    mountButtonLink(CheckedAddressId.DELETE_ADDRESS, () => {
        actions.resetForm();
        actions.deleteAddress();
    });
    mountButtonLink(CheckedAddressId.CHANGE_ADDRESS, () => {
        actions.setOverlayVisibility(true, OverlayContent.AVC);
    });

    if (cityInput && streetInput && houseNumberInput && submitButton) {
        formValidation({
            formFields: [cityInput, streetInput, houseNumberInput],
            submitButton,
        }, true, true);
    }

    // mount components for AVC result overlay
    const avcResultButton = mountButton(AvcResultId.BUTTON);
    const notification = mountNotification(AvcResultId.NOTIFICATION);
    const addressText = mountJustText(AvcResultId.CHECKED_ADDRESS);
    const upsellSection = document.getElementById(AvcResultId.UPSELL);
    const upsellText = mountJustText(AvcResultId.UPSELL_TEXT);
    mountButtonLink(AvcResultId.CHANGE_ADDRESS_BUTTON, () => {
        actions.setOverlayVisibility(true, OverlayContent.AVC);
    });

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const {
                error,
                addressForm,
                addresses,
                isGigakombi,
                isYoung,
                address,
                isTVProductSelected,
                alternativeTariff,
                selectedTariff,
                isSelectedAvailable,
                marketability,
                availableTariffs,
                preSelectedTariff,
                selectedAddress,
            } = newState;
            const update = getUpdateFlags(newState, oldState);
            const availableTariff = selectedTariff ? selectedTariff : alternativeTariff;

            if (update.notification) {
                select?.update(getMultipleAddressSelectProps(addresses));
                setElementVisibility(AvcFormId.MULTIPLE_ADDRESS, error?.type === ErrorType.NOT_UNIQUE_ADDRESS);
                setElementVisibility(AvcFormId.ADDRESS_ERROR, error?.type === ErrorType.NOT_FOUND_ADDRESS);
                setElementVisibility(AvcFormId.SERVICE_ERROR, error?.type === ErrorType.AVC_ERROR);
            }

            if (update.input) {
                cityInput?.update({ stdValue: addressForm.city }, !selectedAddress);
                streetInput?.update({ stdValue: addressForm.street }, !selectedAddress);
                houseNumberInput?.update({ stdValue: addressForm.number }, !selectedAddress);

                if (cityInput && streetInput && houseNumberInput && submitButton) {
                    formValidationHandleBtnDisable({
                        formFields: [cityInput, streetInput, houseNumberInput],
                        submitButton,
                        fieldsWithErrors: [],
                    });
                }
            }

            if (update.avc) {
                notification?.update(getAvcResultNotificationProps(
                    preSelectedTariff,
                    isSelectedAvailable,
                    availableTariffs,
                    marketability,
                ));

                upsellText?.update(getAvcJustTextProps(alternativeTariff));
                setElementVisibility(upsellSection, !selectedTariff);

                avcResultButton?.update(getAvcResultButtonProps(
                    isGigakombi,
                    isYoung,
                    isTVProductSelected,
                    isSelectedAvailable,
                    availableTariff,
                ));

                address && addressText?.update({ content: toAddressString(address) });
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
